import { getCookie, parseNumber } from '@/utils';
import { getSiteCourseList } from '@api';

export default {
  state: {
    siteData: {}
  },
  mutations: {
    SET_SITE_INFO: (state, data) => {
      state.siteData = data;
    }
  },
  actions: {
    getAllSiteInfo: ({ commit }, data) => {
      return new Promise((resolve, reject) => {
        let { flag, majorID } = data;
        majorID = parseNumber(majorID);
        const uid = parseNumber(getCookie('cdeluid'));
        let params = {
          flag: flag,
          majorID: majorID,
          userID: uid
        };
        getSiteCourseList(params)
          .then((res) => {
            resolve(res);
          })
          .catch((err) => {
            reject(err);
          });
      });
    },
    getCurrentSiteInfo: ({ commit }, data) => {
      return new Promise((resolve, reject) => {
        const { flag, majorID, siteCourseID } = data;
        const uid = parseNumber(getCookie('cdeluid'));
        let params = {
          flag: flag,
          majorID: majorID,
          userID: uid
        };
        getSiteCourseList(params)
          .then((res) => {
            let currentItem = {};
            res.forEach((item) => {
              if (item.siteCourseID === siteCourseID) {
                currentItem = item;
              }
            });
            let result = { allSiteList: res, currentCourse: currentItem };
            resolve(result);
            commit('SET_SITE_INFO', result);
          })
          .catch((err) => {
            reject(err);
          });
      });
    }
  }
};
